import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { parse } from 'qs';
import { getAllWorkerJobs } from '../../../actions/workers';
import JobsListBaseComponent from '../../common/JobsListBaseComponent';
import { splitJobsByDate, stringifyWorkerJobsFilterParams } from '../../../helpers/jobs';
import Loader from '../../common/ui/Loader';
import JobListSection from '../jobsList/JobListSection';
import EmptyListUi from '../jobsList/EmptyListUi';
import { jobsListPeriods } from '../../../constants/jobs';
import JobInfoWorker from '../jobsList/JobInfoWorker';
import { getJobWorkerStatusesForFilter } from '../../../helpers/workers';

class WorkerJobsList extends JobsListBaseComponent {
  static propTypes = {
    jobsList: PropTypes.array.isRequired,
    pagesQuantity: PropTypes.number.isRequired,
    getDataAction: PropTypes.func.isRequired
  };

  constructor () {
    super();

    const query = parse(window.location.search, { ignoreQueryPrefix: true });
    const { statuses } = query;

    this.state = {
      period: this.getSelectedPeriod(),
      activePage: this.getActivePage(),
      goToPageBtnIsShown: false,
      isLoading: true,
      statuses: statuses || null
    };
    this.statusesFilter = getJobWorkerStatusesForFilter();
  }

  componentDidMount () {
    this._loadData(this.state.activePage);
  }

  handleStatusChange = event => {
    const statusId = event.target.value;
    const newStatus = this.state.statuses === statusId ? null : statusId;

    this.setState({ statuses: newStatus }, this._loadData);
  };

  _loadData (activePage) {
    this._setDataIsLoading();
    const { period, statuses } = this.state;

    const filterParams = {
      worker_id: this.props.match.params.id,
      period
    };

    if (statuses) {
      filterParams.statuses = statuses;
    }

    super.loadData(activePage, stringifyWorkerJobsFilterParams(filterParams))
      .then(this._setDataLoaded);
  };

  render () {
    const { pagesQuantity } = this.props;
    const { isLoading, period } = this.state;
    const isPastJobsList = period === jobsListPeriods.past.id;
    const jobsListSectionsByDate = splitJobsByDate(this.sortJobsList());
    const jobsListExists = jobsListSectionsByDate.length > 0;

    return (
      <div className='job-list-wrapper'>
        <div className='tabs-wrapper'>
          { this.renderTabs() }
        </div>

        <div className='status-filter-buttons'>
          {this.statusesFilter.map(({ id, value }) => (
            <button
              key={id}
              value={id}
              className={`filter-button ${this.state.statuses === id && 'active'}`}
              children={value}
              onClick={this.handleStatusChange}
            />
          ))}
        </div>

        { isLoading ? <div className='loader-wrapper'><Loader /></div> : (
          <React.Fragment>
            { jobsListExists ? (
              <div className='mt-2'>
                {jobsListSectionsByDate.map(section => (
                  <JobListSection
                    isWorkerDetails
                    key={section.formattedDate}
                    formattedDate={section.formattedDate}
                    weekDay={section.weekDay}
                    jobsList={section.data}
                    history={this.props.history}
                    isPastJobsList={isPastJobsList}
                    JobInfoComponent={JobInfoWorker}
                  />
                ))}
                { pagesQuantity > 1 && this.renderPagination() }
              </div>
            ) : (
              <EmptyListUi
                isCurrentJobsList={!isPastJobsList}
                isWorkerDetails
              />
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    jobsList: state.worker.jobsList,
    pagesQuantity: state.worker.pagesQuantity
  };
};

const mapDispatchToProps = {
  getDataAction: getAllWorkerJobs
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkerJobsList);



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/WorkerJobsList.js